import { CommonModule } from '@angular/common';
import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'safeUrl',
})
export class SafeUrlPipe implements PipeTransform {
  constructor(private domSanitizer: DomSanitizer) {}

  transform(url: string): any {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
  }
}

@NgModule({
  imports: [CommonModule],
  declarations: [SafeUrlPipe],
  exports: [SafeUrlPipe],
})
export class SafeUrlPipeModule {}



// WEBPACK FOOTER //
// ./ts/app/pipes/safe-url.pipe.ts